import PCMPlayer from '../plugins/PcmPlayer'
import WsAudioPlayer from '../plugins/WsAudioPlayer'
import Base64 from 'base64-js';
Vue.component("voice_translate", {
  props: {
    live_info: {
      type: Object,
      default: () => ({})
    },
    player: {
      type: Object,
      default: () => ({})
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  data() {
    this.wsPrefix = location.origin.split('://')[0] == 'http' ? 'ws://' : 'wss://'
    this.audioPlayer = null
    return {
      middleVoice: '',
      voiceTextActive: false,//语音转写开关
      laguages: [],
      voiceList: [],//语音文本列表
      translateVoiceList: [],//开启了同声传译语音文本速度跟随语音速度，用来存放已经读取了的语音文本列表
      voiceTranslateActive: false,//同声传译开关
      translateSrc: '',//当前播放同声传译
      currentVoiceItem: {},
      languageList: [],
      siRoomId: '',//同声传译房间id
      showTextTrack: [],
      voiceToTextWs: {},
      currentTTSVoiceLan: '',//同声传译使用语言
      currentText: null,//当前显示字幕
      currentTextIndex: 0,//倒序
    }
  },
  mounted() { },

  watch: {
    live_info: {
      handler(val) {
        if (Object.keys(val).length && val.voiceIdentify) {
          // this.getLanguageList()
          this.languageList = val.kto
        }
      },
      immediate: true,
    },
    player: {
      handler(p) {
        const that = this
        p?.off('voiceChange', that.onVoiceChange)
        p?.on('voiceChange', that.onVoiceChange)
        // p?.on('timeupdate', that.onTimeUpdate)
      },
      immediate: true,
    }
  },

  methods: {
    formatSeconds(value) {
      if (value == 'Infinity') value = 0
      let result = ''
      let hour = Math.floor(value / 3600);
      let minute = Math.floor(value % 3600 / 60);
      let second = Math.floor(value % 60);
      if (hour > 0) result += hour + ':';
      if (minute < 10) result += '0';
      result += minute + ':';
      if (second < 10) result += '0';
      result += second;
      return result;
    },
    onTimeUpdate(p) {
      const that = this
      if (p.currentLiveTime && this.voiceList.length && !this.voiceTranslateActive) {
        //取一个key作为默认取值key
        let defaultKey = Object.keys(this.voiceList[0])[0]
        if (!defaultKey) return
        let currentText = null
        while (
          this.voiceList[this.voiceList.length - that.currentTextIndex - 1] &&
          this.voiceList[this.voiceList.length - that.currentTextIndex - 1][defaultKey] &&
          (p.currentLiveTime - that.delay) >= this.voiceList[this.voiceList.length - that.currentTextIndex - 1][defaultKey].timestamp / 1000
        ) {
          this.currentTextIndex += 1
          currentText = this.voiceList[this.voiceList.length - that.currentTextIndex - 1]
        }
        if (currentText) {
          that.currentText = currentText
          console.log('currentText', currentText[defaultKey]?.text, that.formatSeconds(p.currentLiveTime))
          Object.keys(currentText).map(key => {
            this.voiceTextActive && that.player?.pushTextTrack({
              key,
              item: {
                part: currentText[key].text
              }
            }, 30000)
          })
        }
      }
    },
    onVoiceChange(index) {
      console.log('音源切换', index, this.player)
      this.currentVoiceItem = this.player.urls[index]
      if (this.voiceTextActive) {
        this.voiceToTextChangeHandle(true, this.laguages)
      }
    },
    // getLanguageList() {
    //   console.log(this.live_info)
    //   if (this.voiceTextActive) {//检查是否需要关闭语音转写
    //     this.voiceTextActive = false
    //     // this.voiceToTextChangeHandle(false)
    //   }
    //   // API.reqTraslateLanguageList().then(res => {
    //   //   if (res.error_msg == 'Success') {
    //   //     this.languageList = [{ code: 'ws', name: '中文' }, ...res.extend_message.enabled_target.filter(el => {
    //   //       return this.live_info?.kto.includes(el.code)
    //   //     })]
    //   //   }
    //   //   console.log(this.live_info)
    //   //   if (this.voiceTextActive) {//检查是否需要关闭语音转写
    //   //     this.voiceTextActive = false
    //   //     // this.voiceToTextChangeHandle(false)
    //   //   }
    //   // })
    // },
    closeAllWs() {
      try {
        Object.keys(this.voiceToTextWs).map(key => {
          this.voiceToTextWs[key]?.close()
        })
      } catch (err) {
        console.error(err)
      }
    },
    //语音转写开关
    voiceToTextChangeHandle(flag, lans) {
      const that = this
      that.currentTextIndex = 0
      //检查是否开启了语音转写
      return new Promise(async (resolve, reject) => {
        that.handleVoiceTranslateClose()//无论开关都先清空同声传译
        if (flag && Object.keys(that.currentVoiceItem).length) {
          //开启语音转写
          //关闭语音转写
          this.closeAllWs()
          if (!that.currentVoiceItem.id) {
            that.$message.error('id不存在')
            that.voiceTextActive = false
            return;
          }

          if (that.currentVoiceItem.muted) {
            that.$message.error('当前直播流无声音，开启语音识别失败！');
            that.voiceTextActive = false
            return;
          }
          // console.error('当前语音流信息', that.currentVoiceItem)
          //后期会接入配置，目前默认暂用中英
          that.live_info.kfr = that.live_info.kfr || 'zh'
          that.live_info.kto = that.live_info.kto || ['zh', 'en']

          let param = {
            live_id: that.live_info.id,
            address: that.currentVoiceItem.pull || that.currentVoiceItem.push || that.currentVoiceItem.path,
            ts: that.live_info.voiceIdentify,
            tts: that.live_info.isSi,
            kfr: that.live_info.kfr,
            kto: that.live_info.kto.map(el => el.code).filter((l) => l != that.live_info.kfr).join(','),//过滤掉源语言
          }
          //开启语音转写
          await API.reqLiveVoiceToTextOpen(param).then(res => {
            if (res.status == 200) {
              that.voiceTextActive = true
              that.languageList = that.languageList.map(el => {
                return {
                  ...el,
                  ws: that.wsPrefix + location.host + res.data[el.code == that.live_info.kfr ? 'ws' : el.code]//源语言使用ws的key
                }
              })
              //默认使用第一个
              if (!this.languageList.length) return that.$message.error('无语言翻译源')
              // this.laguage = this.languageList[0].code
              // this.siRoomId = this.languageList[0].ws?.split('/').slice(-2).shift()
              that.handleChangeLanguage(lans ?? [this.languageList[0].code])
              if (that.player?.status == 0) {
                //未开始播放自动开播
                that.player.play()
              }
              return resolve()
            } else {
              return Promise.reject(res)
            }
          }).catch(err => {
            that.$message.error(err.message || '开启失败')
            that.voiceTextActive = !flag
            that.voiceTranslateActive = that.voiceTextActive
            resolve()
          }).finally(() => {
            resolve()
          })
        } else if (!Object.keys(that.currentVoiceItem).length) {
          that.$message.error('当前直播流无声音!')
          that.voiceTextActive = false
          that.closeAllWs()
          reject()
        } else {
          //关闭语音转写
          that.closeAllWs()
          that.voiceTextActive = false
          reject()
        }
      })
    },
    //翻译开关
    async handleChangeLanguage(lans) {
      const that = this
      let currentWs = this.languageList.filter(el => lans.includes(el.code))
      this.laguages = lans
      this.currentTTSVoiceLan = this.laguages.find(el => el != that.live_info.kfr) || ''
      //置空转写过程
      this.middleVoice = ''
      currentWs.map(current => {
        this.siRoomId = current.ws?.split('/').slice(-2).shift().split('_')[0]
        if (current.code != that.live_info.kfr) {
          //非源语言调接口
          API.reqLiveTransitionOpen({ room_id: this.siRoomId, kt: current.code })
        }
        this.openWs(current)
      })
      this.player?.setOption({
        textTrack: this.live_info.kto?.filter(el => lans.includes(el.code)).map(el => {
          return {
            label: el.name,
            srclang: el.code,
            default: true
          }
        })
      })
    },
    openWs(item) {
      const { ws, code } = item
      return new Promise((resolve, reject) => {
        if ('WebSocket' in window) {
          if (this.voiceToTextWs[code]) this.voiceToTextWs[code].close()
          this.voiceToTextWs[code] = new WebSocket(ws)
          this.voiceToTextWs[code].onopen = function () {
            console.log('ws连接成功')
            resolve()
          }
          this.voiceToTextWs[code].onmessage = (e) => {
            this.handleWsMessage(e, code)
          }
          this.voiceToTextWs[code].onclose = function (e) {
            console.log('ws关闭')
          }
          this.voiceToTextWs[code].onerror = function (err) {
            console.error('ws出错', err)
          }
        } else {
          console.error('您的浏览器不支持WebSocket')
        }
      })
    },
    onAudioChange(data) {
      // console.error('切换', event)
      if (this.voiceTranslateActive) {
        //开启了同声传译，字幕跟随语音
        let defaultKey = Object.keys(this.voiceList[0])[0]
        if (!defaultKey) return
        let showItem = this.voiceList?.find(el => el[defaultKey]?.timestamp == data.timestamp)
        // console.log(showItem)
        if (!showItem) return
        this.translateVoiceList.unshift(showItem)
        Object.keys(showItem).map(key => {
          const obj = {
            key,
            item: {
              part: showItem[key].text
            }
          }
          this.voiceTextActive && this.player?.pushTextTrack(obj, 30000)
        })
      }
    },
    //处理ws结果
    handleWsMessage(evt, code) {
      const that = this
      if (evt.data) {
        const res = JSON.parse(evt.data);
        switch (res.code) {
          case 0:
          case 1:
          case 2:
          case 4:
            this.handleSmartText(res, code);
            break;
          case 3:
            //同声传译
            if (code == this.currentTTSVoiceLan && res.kwargs) {
              if (!this.audioPlayer) {
                if (res.kwargs?.audio_format == 'pcm') {
                  this.audioPlayer = new PCMPlayer({
                    inputCodec: res.kwargs?.audio_config?.resolution || 'Int16', // 采样位数
                    channels: 1, // 单通道
                    sampleRate: res.kwargs?.audio_config?.sample_rate || 16000, // 采样率
                    flushingTime: 2000, // pcm刷新间隔
                    onstatechange: (node, event, type) => {
                    }, // 播放状态变化事件
                    onended: (node, event) => {
                    }, // 播放结束事件
                    onchange: (node, data) => {
                      that.onAudioChange(data)
                    },
                    ...(config ?? {})
                  });
                } else {
                  //mp3、wav
                  this.audioPlayer = new WsAudioPlayer({
                    type: res.kwargs?.audio_format,
                    onchange: (node, data) => {
                      that.onAudioChange(data)
                    },
                  })
                }
              }
              this.voiceTranslateActive && this.audioPush(res.extend)
            }
            break;
          case 10: // 直播结束
            // setErrorInfo('直播已结束');
            // setSmart(false);
            // setStream([]);
            // wsInstance.current.smartWs.close();
            // wsInstance.current.roomWs.close();
            break;
          case 11: //在线观看人数
            // setOnlineNums(Number(res.extend));
            break;
          case 301:
            this.$message.error('流地址解析错误');
            break;
          case 302:
            this.$message.error('语音识别（翻译）服务器连接错误');
            break;
          case 300:
            this.$message.error('服务器错误');
            break;
          default:
            break;
        }
      }
    },
    //处理信息
    handleSmartText(res, key) {
      // 去掉首字符标点符号
      if (res.extend.text.match(/^(，|。|；|？|、|：)/)) {
        res.extend.text = res.extend.text.slice(1);
      }
      let showItem = {}
      let arr = []
      let index = 0
      switch (res.code) {
        case 0: // 语音识别结果或翻译结果
          if (this.laguages.includes('ws') && key == 'ws') {
            //选择了源语言的默认展示源语言
            this.middleVoice = ''
          } else if (key == this.laguages[0]) {
            //否则默认选择的第一路
            this.middleVoice = ''
          }
          const { extend } = res
          arr = [...this.voiceList]
          index = arr.findIndex(el => {
            //找到同时间点的数据
            return (el[Object.keys(el)[0]].timestamp == extend.timestamp)
          })
          if (index > -1) {
            //将同时间点片段放入同一项
            arr[index][key] = extend
            showItem = arr[index]
          } else {
            arr.unshift({ [key]: extend })
            showItem = { [key]: extend }
          }
          // console.log(arr)
          this.voiceList = arr
          break;
        case 1: // 语音识别中间过程
          if (this.laguages.length == 1 && key == this.laguages[0]) {
            //只选择了一门语言则显示这路语言的中间过程
            this.middleVoice = res.extend.text
          } else if (this.laguages.length && this.laguages.includes(this.live_info.kfr) && key == this.live_info.kfr) {
            //选择了源语言的默认展示源语言
            this.middleVoice = res.extend.text
          }
          if (this.voiceTextActive && !this.voiceTranslateActive) {
            //开启了语音转写且未开启同声传译，展示转写过程
            this.player?.pushTextTrack({
              key,
              item: {
                part: res.extend.text
              }
            }, 30000)
          }

          break;
        default:
          break;
      }
      if (Object.keys(showItem).length && this.laguages.length && Object.keys(showItem).length == this.laguages.length && !this.player.currentLiveTime && !this.voiceTranslateActive) {
        //选中语言都接收到，显示字幕
        Object.keys(showItem).map(key => {
          const obj = {
            key,
            item: {
              part: showItem[key].text
            }
          }
          // console.log(obj)
          this.voiceTextActive && this.player?.pushTextTrack(obj, 30000)
        })
      }
    },
    //同声传译开关
    async handleVoiceTranslateOpen() {
      if (!this.live_info.voiceIdentify) return this.$message.info('未开启语音转写')//未开启语音转写功能
      let flag = true
      //未开启语音转写先开启
      if (!this.voiceTextActive || this.laguages.length < 2) await this.voiceToTextChangeHandle(true, this.languageList.slice(0, 2).map(el => el.code));
      if (!this.voiceTextActive) return this.$message.error('语音转写开启失败！')//语音转写开启失败
      if (!this.siRoomId) return this.$message.error('获取房间号失败！')
      //同声传译开启了使用translateVoiceList展示语音文本列表
      this.translateVoiceList = [...this.voiceList]
      //已开启语音转写，调接口开启同声传译
      API.reqLiveVoiceTransitionOpen({ room_id: this.siRoomId, kt: this.currentTTSVoiceLan }).then(res => {
        if (res.status != 200) {
          this.$message.error('同声传译开启失败！')
          flag = false
        } else {
          // this.$message.success('同声传译开启成功！')
        }
      }).catch(err => {
        this.$message.error('同声传译开启失败！')
        flag = false
      }).finally(() => {
        this.voiceTranslateActive = flag
        this.player?.setMuted(flag)
        this.$emit('onsichange', this.voiceTranslateActive)
      })
    },
    //关闭同声传译
    handleVoiceTranslateClose() {
      this.player?.setMuted(false)
      this.translateSrc = ''
      this.voiceTranslateActive = false
      this.$emit('onsichange', this.voiceTranslateActive)
      this.audioPlayer?.stop()
    },
    //pcm播放器push数据
    audioPush(data) {
      let source = data.text.replace(/^data:audio\/raw;base64,/, '');
      this.audioPlayer.feed({ source: Base64.toByteArray(source), data })
      this.audioPlayer.volume(10);
      this.audioPlayer.continue();
    },
  },
  template: `
  <div class="voice_translate">
    <el-tooltip effect="dark" content="管理员未开启此功能" placement="top" :disabled="live_info && live_info.voiceIdentify">
      <div class="setting_panel">
          <div class="switch">
              <el-switch :disabled="live_info && !live_info.voiceIdentify" v-model="voiceTextActive" @change="voiceToTextChangeHandle"></el-switch>
              <span>{{voiceTextActive?'开启':'关闭'}}</span>
          </div>
          <el-select multiple :disabled="!voiceTextActive" size="small" v-model="laguages" @change="handleChangeLanguage">
              <el-option v-for="item in languageList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
      </div>
    </el-tooltip>
    <div class="voice_list">
        <div class="voice_item" v-if="!voiceTranslateActive">{{middleVoice}}</div>
        <div class="voice_item" v-for="(item, i) in (voiceTranslateActive? translateVoiceList: voiceList)" :key="i">
            <p v-for="key in laguages" :key="key">{{item[key]?.text || ''}}</p>
        </div>
    </div>
  </div>
  `,
});